/* eslint-disable react/display-name */
import React, { useState } from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { Col, Image, Row, Space } from 'antd'
import { appConfig } from 'config'
import { TableListPage } from 'Components/common/Table'
import { CheckSquareOutlined, DeleteOutlined } from '@ant-design/icons'
import { ImageFallback } from 'helpers/constanst'
import { selectPosBill } from 'Store/orders/selector'
import RootState from 'typings/RootState'
import { connect } from 'react-redux'
import { ActionButton, PrimaryButton } from 'Components/button'
import ProductsDrawer from './ProductsDrawer'
import { QuotationProduct } from 'Store/quotation/types'
import { OverstockTag } from 'Components/utilities'
import { PointProductConfig } from 'Store/member-point/types'

type Props = {
  products: PointProductConfig[]
  disableProduct: PointProductConfig[]
  onUpdateData?: (products: PointProductConfig[]) => void
} & ReduxProps

const ProductsTable: React.FunctionComponent<Props> = props => {
  const [chooseProduct, setChooseProduct] = useState(false)
  const { products, onUpdateData = () => {}, disableProduct } = props

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const onRemoveProduct = (product: QuotationProduct, removeIndex: number) => {
    const newProduct = products && products.filter((item, index) => index != removeIndex)
    onUpdateData(newProduct)
  }

  const renderImage = (photo: any) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + photo} fallback={ImageFallback} />
  )

  const renderActionButton = (text: string, record: any, index: number) => (
    <Space size="middle">
      <ActionButton
        text=""
        icon={<DeleteOutlined />}
        label="ลบสินค้า"
        action="view"
        onClick={() => onRemoveProduct(record, index)}
      />
    </Space>
  )

  const renderProductCode = (val: string) => {
    return val
  }

  const renderProductName = (val: string, record: QuotationProduct) => {
    const isSameTitle = record.title == record.product_option_title
    return (
      <>
        <RowTile>{record.title}</RowTile>
        {!isSameTitle && <ProductDesc>{record.product_option_title}</ProductDesc>}
        <OverstockTag isOverstock={record.sale_item_type === 'overstock'} />
      </>
    )
  }

  const columns = [
    {
      title: <ColTile>ลำดับ</ColTile>,
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return renderInfo(index + 1)
      },
      width: '50px',
    },
    {
      title: <ColTile>รูปภาพ</ColTile>,
      dataIndex: 'picture',
      key: 'picture',
      width: '70px',
      render: renderImage,
    },
    {
      title: <ColTile>รหัสสินค้า</ColTile>,
      dataIndex: 'code',
      key: 'code',
      width: '100px',
      render: renderProductCode,
    },
    {
      title: <ColTile>รายการ</ColTile>,
      dataIndex: 'title',
      key: 'title',
      render: renderProductName,
    },
    {
      title: 'ยี่ห้อ',
      dataIndex: 'brand',
      key: 'brand',
    },
    {
      title: 'หน่วย',
      dataIndex: 'unit',
      key: 'unit',
    },
    {
      title: '',
      key: 'action',
      width: '50px',
      render: renderActionButton,
    },
  ]

  const ChooseProductsDrawer = (
    <ProductsDrawer
      visible={chooseProduct}
      onCloseDrawer={() => setChooseProduct(false)}
      onSaveProduct={(products: PointProductConfig[]) => {
        onUpdateData(products)
        setChooseProduct(false)
      }}
      products={products}
      disableProduct={disableProduct}
    />
  )

  return (
    <BoxWrapper>
      <Row gutter={[16, 8]}>
        <Col span={24}>
          <TableListPage
            rowKey="product_option_id"
            tableName="product-purchase"
            columns={columns}
            datas={products}
            size={'small'}
            scrollX={800}
            // rowClassName={(record: QuotationProduct) =>
            //   viewMode && record.sale_item_type === 'overstock' ? 'overstock' : ''
            // }
          />
        </Col>
      </Row>
      <Row justify="space-between" gutter={[8, 8]}>
        <Col>
          <PrimaryButton
            btnType="Primary"
            text="เลือกสินค้า"
            onClick={() => setChooseProduct(true)}
            icon={<CheckSquareOutlined />}
            size="middle"
          />
        </Col>
      </Row>
      {ChooseProductsDrawer}
    </BoxWrapper>
  )
}

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 60px;
  height: 60px;
  object-fit: cover;
`

const ColTile = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const mapStateToProps = (state: RootState) => {
  return {
    billData: selectPosBill(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ProductsTable)
